/* eslint-disable import/prefer-default-export */

import getFilterWithCol from '../../helpers/getFilterWithCol';

export const createDefaultFields = () => ([
  ['FieldSelect', {
    name: 'defaultConfig.model',
    label: 'Config',
    prefix: 'Model:',
    choices: [
      'gpt-4-1106-preview',
      'gpt-4',
      'gpt-3.5-turbo-16k',
      'gpt-3.5-turbo-1106',
      'gpt-3.5-turbo',
      'gpt-4o-mini',
    ].map(value => ({
      label: value,
      value,
    })),
  }],
  ...[
    ['temperature', 'Temperature'],
    ['topP', 'Top P'],
    ['maxTokens', 'Max Tokens'],
  ].map(([name, label]) => getFilterWithCol(
    ['FieldText', {
      name: `defaultConfig.${name}`,
      type: 'number',
      label: null,
      prefix: `${label}:`,
    }],
    8,
  )),
  ['FieldTextArea', {
    name: 'defaultPrompt',
    label: 'Prompt',
    placeholder: 'Prompt template for AI',
    autoSize: { minRows: 3 },
    fontFamily: 'Menlo',
    fontSize: '80%',
  }],
]);
